import React, {Component} from "react";
import styled, {css} from "styled-components";

import logo from "./images/lls-logo.svg";
import shopperNowLogo from "./images/shopperNowLogo.png";
import sundialLogo from "./images/sundialLogo.png";

import colors from "open-color";

const LayoutWrapper = styled.div`
  font: "Manrope", sans-serif;
  min-height: 100vh;
  text-align: center;
  color: white;
`;
const CannaTraceWrapper = styled.div`
  background-color: ${colors.gray[9]};
`;
const ProtoTerpWrapper = styled.div`
  background-color: ${colors.gray[3]};
`;
const ShopperNowWrapper = styled.div`
  background-color: ${colors.gray[8]};
`;

const GradientWrapper1 = styled.div`
  background: linear-gradient(to bottom left, ${colors.gray[7]}, ${colors.gray[8]});
`;

const Header = styled.div`
  padding-top: 2em;
  min-height: 10rem;
  font-weight: 100;
  font-size: 3.2rem;
`;
const HeaderLogo = styled.div`
  width: 1em;
  display: inline-block;
  vertical-align: middle;
  padding-right: 0.5em;
`;

const Heading1 = styled.div`
  font-size: 3.1rem;
  font-weight: 100;
  color: ${colors.gray[2]};

  ${props =>
    props.dark &&
    css`
      color: ${colors.gray[9]};
    `};
  @media (max-width: 800px) {
    font-size: 2.1rem;
  }
`;
const Heading2 = styled.div`
  font-size: 1.9rem;
  font-weight: 300;
  margin: 1em 0.2em 1em 0.2em;
  color: ${colors.gray[2]};
  @media (max-width: 800px) {
    font-size: 1.7rem;
  }
`;
const Heading3 = styled.div`
  font-weight: 900;
  font-size: 1.72rem;
  color: ${colors.gray[2]};
  margin-bottom: 0.618em;
`;
const Heading4 = styled.div`
  font-size: 2.6rem;
  font-weight: 100;
  color: ${colors.gray[2]};
  ${props =>
    props.dark &&
    css`
      color: ${colors.gray[9]};
    `};
  @media (max-width: 800px) {
    font-size: 1.9rem;
  }
`;
const Heading5 = styled.div`
  font-weight: 900;
  font-size: 1.1rem;
  color: ${colors.gray[2]};
`;

const HeadingBar = styled.div`
  background-color: ${colors.gray[8]};
  display: flex;
  justify-content: center;
`;
const Container = styled.div`
  margin: auto;
  max-width: 92vw;
  ${props =>
    props.text &&
    css`
      padding-left: 1em;
      padding-right: 1em;
      max-width: 84rem;
    `};
  ${props =>
    props.fluid &&
    css`
      max-width: 100%;
    `};
  ${props =>
    props.narrow &&
    css`
      max-width: 54rem;
    `};
  @media (max-width: 800px) {
    max-width: 90vw;
  }
`;

const Grid2 = styled.div`
  display: grid;
  max-width: 95vh;
  max-width: 78rem;
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
  align-content: space-around;
  align-items: space-between;
  justify-items: center;

  grid-gap: 2rem;
  grid-template-columns: 1fr 1fr;
  @media (max-width: 800px) {
    grid-template-columns: 1fr;
    grid-gap: 1rem;
  }
`;

const CannaTraceLogo = styled.div`
  padding: 2em;
  color: ${colors.gray[6]};
  max-width: 95%;
`;
const ProtoTerpLogo = styled.div`
  padding: 1em;
  color: ${colors.gray[9]};
`;
const ShopperNowLogo = styled.div`
  margin: auto;
  max-width: 30rem;
  padding: 1em;
  color: ${colors.gray[2]};
`;
const SundialLogo = styled.div`
  margin: auto;
  max-width: 40rem;
  padding: 1em;
  color: ${colors.gray[2]};
`;
const Pad = styled.div`
  font-size: 3rem;
  padding: 4em;
  ${props =>
    props.padding &&
    css`
      padding: ${props.padding};
    `};
`;

const Circle = styled.div`
  margin: 2rem;
  //display: inline-block;
  border-radius: 50%;
  width: 18rem;
  height: 18rem;
  background-color: ${colors.gray[7]};
  font-size: 1.1rem;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 2fr 1fr;
  justify-content: start;
  padding: 3rem 2rem 2rem 2rem;
`;
const CircleIcon = styled.div`
  font-size: 11.2rem;
  margin: 0rem;
`;

const CircleTitle = styled.div`
  font-size: 1.2rem;
  font-weight: 700;
  //margin-top: -1rem;
  //line-height: 1em;
`;
const TextBlock = styled.div`
  padding: 2em 0.8em 2em 0.8em;
  font-size: 1.1rem;
  font-weight: 600;
  text-align: left;
`;
const CannaTraceTextWrapper = styled.div`
  align-self: center;
  text-align: left;
  max-width: 90vw;
  @media (max-width: 800px) {
    text-align: center;
  }
`;
const CannaTraceTextBlock = styled.div`
  margin-top: 1rem;
  font-weight: 300;
  font-size: 1.72rem;
  color: ${colors.gray[2]};
  @media (max-width: 800px) {
    font-size: 1.42rem;
  }
`;
const CannaTraceHeader = Heading1.extend`
  text-align: left;
  @media (max-width: 800px) {
    font-size: 2.6rem;
    text-align: center;
  }
`;

const LinkTo = styled.a`
  color: ${colors.gray[0]};
  font-weight: 700;
  text-decoration: none;
`;

const Footer = styled.div`
  padding: 3rem 1rem 1rem 1rem;
  background-color: ${colors.gray[9]};
  color: ${colors.gray[0]};
`;
const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin-bottom: 4rem;
`;
const FooterCopyright = styled.div``;

const FlexCenter = styled.div`
  display: flex;
  justify-content: center;
`;

class App extends Component {
    render() {
        return (
            <LayoutWrapper>
                <GradientWrapper1>
                    <Header>
                        <HeaderLogo>
                            <img src={logo} width="100%"/>
                        </HeaderLogo>
                        Little Lake Studios
                    </Header>
                    <Container text>
                        <Heading2>
                            We are a small team of dedicated professionals from Northern California creating powerful
                            tools and
                            exciting applications for interacting with this world we live in.
                        </Heading2>
                        <Pad padding="1.2em"/>
                    </Container>


                    <Container text>
                        <Heading3>
                            Map Making / Cartography
                        </Heading3>
                        <Heading3>
                            Integrated Site Design
                        </Heading3>
                        <Heading3>
                            Living Water Systems
                        </Heading3>
                            <Heading3>
                                Bioenergetic Compost Tea
                            </Heading3>
                            <Heading3>
                                Custom Web Sites
                            </Heading3>
                            <Heading3>
                                Database Design & Build
                            </Heading3>
                            <Heading3>
                                App Design & Build
                            </Heading3>
                            <Heading3>
                                Programming Services
                            </Heading3>
                            <Heading3>
                                Track and Trace
                            </Heading3>
                            <Heading3>
                                Security Solutions
                            </Heading3>

                    </Container>

                    <Pad padding="2em"/>
                    <Container text>
                        <Heading1>
                            Our team has an extensive background in Agriculture, Software Design, Performance and Media
                            with over 20
                            years' experience.
                        </Heading1>
                    </Container>
                    <Pad/>
                </GradientWrapper1>
                <HeadingBar>
                    <Heading2>Latest Projects</Heading2>
                </HeadingBar>
                {/*
        <CannaTraceWrapper>
          <Container text>
            <Pad />
            <Grid2>
              <CannaTraceLogo>
                <img width="100%" src={cannaTraceLogo} />
              </CannaTraceLogo>
              <CannaTraceTextWrapper>
                <CannaTraceHeader>CannaTrace.App</CannaTraceHeader>
                <CannaTraceTextBlock>
                  Prmiere Cannabis Cultivation Business App organizes your Grow from planning through harvest and sales.
                  Currently in production with automatic full support for Mendocino County track and trace. CannaTrace
                  is currently in development and should be open to the public around September 2018.
                </CannaTraceTextBlock>
              </CannaTraceTextWrapper>
            </Grid2>
            <Pad padding="2em" />
          </Container>
        </CannaTraceWrapper>
        <ProtoTerpWrapper>
          <Container narrow>
            <Pad />
            <ProtoTerpLogo>
              <img width="100%" src={protoTerpLogo} />
            </ProtoTerpLogo>
            <Heading4 dark>
              Visualize the smell of cannabis. Compare your strains. Community powered database of cannabinoids and
              terpenes. <br />
              Upload your terps today.
            </Heading4>
            <Pad />
          </Container>
        </ProtoTerpWrapper>
        */}
                <ShopperNowWrapper>
                    <Container text>
                        <Pad/>
                        <ShopperNowLogo>
                            <img width="100%" src={shopperNowLogo}/>
                        </ShopperNowLogo>
                        <Heading2>Integrated E-Commerce Solution for Small Business</Heading2>
                        <Heading1>
                            Custom Design
                            <br/>
                            Marketing Campaigns
                            <br/>
                            Simple Newsletter Mailings
                            <br/>
                            Discounts & Coupons
                            <br/>
                            Wholesale
                            <br/>
                            Shipping & Shipment Tracking
                            <br/>
                            Credit Card Processing
                            <br/>
                            Graphs and Reports
                            <br/>
                        </Heading1>
                        <Heading2>
                            <LinkTo href="mailto:info@littlelakestudios.com">
                                Talk to us about custom features for your business.
                            </LinkTo>
                        </Heading2>
                        <Pad padding="1em"/>
                        <SundialLogo>
                            <img src={sundialLogo} width="100%"/>
                        </SundialLogo>
                        <Pad padding="1rem"/>
                        <Heading4>
                            ShopperNow is used to provide a custom solution for Sundial Seed Company located in Willits,
                            CA
                        </Heading4>
                        <Heading2>
                            <LinkTo href="https://www.sundialseed.com">www.sundialseed.com</LinkTo>
                        </Heading2>
                        <Pad padding="2em"/>
                    </Container>
                </ShopperNowWrapper>
                <Footer>
                    <FooterGrid>
                        <LinkTo href="mailto:info@littlelakestudios.com">info@littlelakestudios.com</LinkTo>
                    </FooterGrid>
                    <Heading5>Copyright 2018 Little Lake Studios Inc.</Heading5>
                </Footer>
            </LayoutWrapper>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js